<script setup lang="ts">
import { computed } from 'vue'
import { useUserStore } from '@/stores/modules/user'
import type { SkillItemType } from '@/types/skill'
import SkillInfo from './SkillInfo.vue'

const userStore = useUserStore()

const props = defineProps<{ skillInfo: SkillItemType; index: number }>()
const emits = defineEmits(['close'])

const equippedSkillInfo = computed(() => {
  const id = userStore.skillEquippedList[props.index]
  return userStore.skillList.find((item) => item.id === id)
})
</script>

<template>
  <div class="skill-comparsion">
    <div class="module equipped">
      <h5>携带中</h5>
      <template v-if="equippedSkillInfo">
        <SkillInfo :skill-info="equippedSkillInfo" :showLock="false" :is-in-items="false" :is-in-comparison="true" @close-compare="emits('close')" />
      </template>
      <template v-else>
        <p style="text-align: center">(未携带)</p>
      </template>
    </div>
    <div class="module in-items">
      <h5>物品栏</h5>
      <SkillInfo :skill-info="skillInfo" :showLock="false" :is-in-items="true" :is-in-comparison="true" @close-compare="emits('close')" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.skill-comparsion {
  display: flex;
  justify-content: space-between;
  h5 {
    margin: 10px 0;
  }
  .module {
    width: calc(50% - 5px);
    border: 2px var(--fontColor) solid;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    flex-flow: column nowrap;
    min-height: 320px;
  }
}
</style>
